import React from "react";
import * as XLSX from "xlsx";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";
import { useAuth } from "../../../../Context/AuthContext";
import { formatDateTime12Hour } from "../../../../utils/dateTimeFormat";

const getStatusLabel = (status) => {
  const statusMap = {
    pending: "قيد الانتظار",
    finished: "منتهي",
    canceled: "ملغي",
    underway: "قيد التنفيذ",
    out_of_preparation: "خارج التحضير",
    delivered: "تم التوصيل",
    under_review: "قيد المراجعة",
  };
  return statusMap[status] || status || "-";
};

const formatNumber = (value) => {
  const num = Number.parseFloat(value || 0);
  return Number.isNaN(num) ? "0.00" : num.toFixed(2);
};

const ExportInvoicesExcelButton = ({ invoices = [], getOrderTypeLabel }) => {
  const { hasPermission } = useAuth();

  const handleExport = () => {
    if (!Array.isArray(invoices) || invoices.length === 0) return;

    const headers = [
      "المسلسل",
      "رقم الفاتورة",
      "رقم الطلب",
      "رقم الطلب اليومي",
      "رقم الطلب الشهري",
      "اسم العميل",
      "هاتف العميل",
      "بريد العميل",
      "اسم المستخدم",
      "اسم دخول المستخدم",
      "هاتف المستخدم",
      "بريد المستخدم",
      "نوع الطلب",
      "حالة الطلب",
      "تاريخ الفاتورة",
      "الإجمالي الفرعي",
      "الخدمة",
      "نسبة الخدمة",
      "التوصيل",
      "نسبة التوصيل",
      "الضريبة",
      "نسبة الضريبة",
      "الخصم",
      "نسبة الخصم",
      "الإجمالي النهائي",
    ];

    const rows = invoices.map((invoice, index) => [
      index + 1,
      invoice?.id || "-",
      invoice?.order?.general_increment || "-",
      invoice?.order?.daily_increment || "-",
      invoice?.order?.monthly_increment || "-",
      invoice?.order?.customer?.name || "-",
      invoice?.order?.customer?.phone || invoice?.order?.customer?.phone2 || "-",
      invoice?.order?.customer?.email || "-",
      invoice?.user?.name || "-",
      invoice?.user?.username || "-",
      invoice?.user?.phone || "-",
      invoice?.user?.email || "-",
      getOrderTypeLabel?.(invoice?.order?.order_type) || invoice?.order?.order_type || "-",
      getStatusLabel(invoice?.order?.status),
      formatDateTime12Hour(invoice?.created_at),
      formatNumber(invoice?.sub_total),
      formatNumber(invoice?.service),
      `${invoice?.service_ratio ?? 0}%`,
      formatNumber(invoice?.delivery_service),
      `${invoice?.delivery_service_ratio ?? 0}%`,
      formatNumber(invoice?.tax),
      `${invoice?.tax_ratio ?? 0}%`,
      formatNumber(invoice?.discount),
      `${invoice?.discount_ratio ?? 0}%`,
      formatNumber(invoice?.total_amount),
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    worksheet["!cols"] = [
      { wch: 10 },
      { wch: 14 },
      { wch: 14 },
      { wch: 16 },
      { wch: 16 },
      { wch: 24 },
      { wch: 18 },
      { wch: 24 },
      { wch: 22 },
      { wch: 20 },
      { wch: 18 },
      { wch: 24 },
      { wch: 14 },
      { wch: 16 },
      { wch: 24 },
      { wch: 16 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 18 },
    ];

    const workbook = XLSX.utils.book_new();
    workbook.Workbook = { Views: [{ RTL: true }] };
    XLSX.utils.book_append_sheet(workbook, worksheet, "الفواتير");
    const date = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `invoices_export_${date}.xlsx`);
  };

  return (
    <Tooltip title="تصدير البيانات إلى Excel" arrow>
      <span>
                    {hasPermission("export") && (

        <Button
          variant="outlined"
          color="success"
          startIcon={<DownloadIcon />}
          onClick={handleExport}
          disabled={!invoices.length}
          sx={{ whiteSpace: "nowrap" }}
        >
          تصدير Excel
        </Button>
                      )}
      </span>
    </Tooltip>
  );
};

export default ExportInvoicesExcelButton;
